import React from 'react';

export default function Spinner(props) {

    return (
        <div className="d-flex" aria-label="Chargement">
            <div className="mnh-h"/>
            <div className={ props.spinClasses + ' spin-mnh'}/>
        </div>
    );
}